import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
  UPDATE_DEPARTMENT_PTO_FAILURE,
  UPDATE_DEPARTMENT_PTO_REQUEST,
  UPDATE_DEPARTMENT_PTO_SUCCESS,
} = departmentDashboard;

function* updateDepartmentPTORequest(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(departmentDashboardService.updateDepartmentPTORequest, payload);
    if (response?.status === 200) {
      yield put({ type: UPDATE_DEPARTMENT_PTO_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_DEPARTMENT_PTO_FAILURE, payload: error });
  }
}

function* updateDepartmentPTORequestSaga() {
  yield takeEvery(UPDATE_DEPARTMENT_PTO_REQUEST, updateDepartmentPTORequest);
}

export default updateDepartmentPTORequestSaga;
